<div class="card">
  <div [ngSwitch]="status">
    <div *ngSwitchCase="'verified'" class="card-body">
      <h3 class="card-title">Account verified</h3>
      <p>
        Your account has been verified, you will need to sign in one more time to access the resources you requested. Please choose from one of the following links:
      </p>
    </div>
    <div *ngSwitchCase="'error'" class="card-body">
      <h3 class="card-title">Account verification failed</h3>
      <p>
        This could be because the verification code expired or was already used.
        <br/><br/> To get a new verification email, please attempt to sign in again and another email will be sent to your email address.
      </p>
    </div>
    <!-- default action -->
    <div *ngSwitchDefault class="card-body">
      <h3 class="card-title">Account verification </h3>
      <app-progress-bar></app-progress-bar>
    </div>
  </div>
  <div class="card-body">
    <div class="d-grid gap-2">
      <a *ngFor="let endpoint of environmentIapEndpoints"
      class="btn btn-primary btn-lg btn-block q-button" role="button" href="{{endpoint.url}}">
        {{endpoint.buttonText}}
      </a>
    </div>
  </div>
</div>